/* Ordered cards; no video/source or media request before explicit activation. */
if (!customElements.get('hafizah-product-videos')) {
  customElements.define('hafizah-product-videos', class extends HTMLElement {
    connectedCallback() {
      if (!this.bound) {
        this.bound = true;
        this.track = this.querySelector('.product-videos__track');
        this.addEventListener('click', (event) => {
          const play = event.target.closest('[data-play]');
          const step = event.target.closest('[data-step]');
          const expand = event.target.closest('[data-expand]');
          if (play) this.activate(play.closest('.product-videos__card'));
          if (step) this.scroll(Number(step.dataset.step));
          if (expand && this.player) {
            try {
              if (this.player.requestFullscreen) this.player.requestFullscreen().catch(() => {});
              else this.player.webkitEnterFullscreen?.();
            } catch (_) { /* Native controls remain available. */ }
          }
        });
        this.track.addEventListener('scroll', () => this.updateNavigation(), { passive: true });
        this.resizeObserver = new ResizeObserver(() => this.updateNavigation());
      }
      this.resizeObserver.observe(this.track);
      this.updateNavigation();
    }
    updateNavigation() {
      const previous = this.querySelector('[data-step="-1"]');
      const next = this.querySelector('[data-step="1"]');
      if (!previous || !next) return;
      const position = Math.abs(this.track.scrollLeft);
      previous.disabled = position < 2;
      next.disabled = position + this.track.clientWidth >= this.track.scrollWidth - 2;
    }
    scroll(step) {
      const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({ left: step * direction * this.track.clientWidth * .8, behavior: reduced ? 'auto' : 'smooth' });
    }
    activate(card) {
      if (this.activeCard === card) return;
      this.reset();
      const player = document.createElement('video');
      player.controls = true;
      player.playsInline = true;
      player.preload = 'none';
      player.tabIndex = 0;
      player.setAttribute('aria-label', card.dataset.videoLabel);
      const poster = card.querySelector('img');
      if (poster) player.poster = poster.currentSrc || poster.src;
      player.addEventListener('error', () => {
        if (this.player === player) this.reset(true);
      }, { once: true });
      this.activeCard = card;
      this.player = player;
      card.querySelector('[role="status"]').hidden = true;
      card.querySelector('[data-play]').hidden = true;
      card.querySelector('[data-expand]').hidden = false;
      card.append(player);
      player.src = card.dataset.videoUrl;
      player.focus({ preventScroll: true });
      const playback = player.play();
      if (playback) playback.catch(() => {});
    }
    reset(failed = false) {
      const card = this.activeCard;
      const player = this.player;
      this.player = null;
      this.activeCard = null;
      if (player) {
        player.pause();
        player.removeAttribute('src');
        player.load();
        player.remove();
      }
      if (!card) return;
      const button = card.querySelector('[data-play]');
      button.hidden = false;
      card.querySelector('[data-expand]').hidden = true;
      if (failed && this.isConnected) {
        const status = card.querySelector('[role="status"]');
        status.textContent = this.dataset.errorMessage;
        status.hidden = false;
        button.focus({ preventScroll: true });
      }
    }
    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.reset();
    }
  });
}
